import Vue from 'vue';
import main from './error-modal.vue';
const ToastConstructor = Vue.extend(main);
let instance;
const TokenErrorModal = function (options){
  instance = new ToastConstructor({
    data:options
  }).$mount();//渲染组件
  document.body.appendChild(instance.$el);//将组件挂载在body下
};
//当需要成功或者失败的回调时，可以选择以下方法
['success','error'].forEach((item)=>{
  TokenErrorModal[item]=options=>{
    options.type=item;
    return TokenErrorModal(options);
  }
})
export default TokenErrorModal;
